

import { Box, Paper, Table, TableContainer } from "@mui/material"





export const LayoutTabla = ({ children, paginado, mt=0, mb=0,  sx={} }) => {


    return (
        <Paper sx={{ width:'100%', overflowX:'auto', position:'relative', mt:mt, mb:mb, ...sx }}>
            <TableContainer>
                <Table sx={{ minWidth:900, tableLayout:"fixed" }}>
                    { children }
                </Table>
            </TableContainer>


            {paginado && (
                <Box sx={{ width:'100%', overflowX:'auto', overflowY:'hidden',
                    borderTop:1, borderColor:'divider', px:3, display:'flex', scrollBehavior:'smooth',
                    '&::-webkit-scrollbar': { height: 6 }, 
                    '&::-webkit-scrollbar-thumb': { borderRadius:3},
                    '& .MuiPagination-ul': { flexWrap:'nowrap', ml:'auto',  },
                }}>
                    <Box sx={{ display:'flex', justifyContent:'center', width:'max-content', mx:'auto', '& .MuiPagination-ul':{flexWrap:'nowrap'} }}>
                        
                        { paginado }

                    </Box>
                </Box>
            )}
        </Paper>
    )
}
